import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ItemNotification = (props) => {
  const [state, setState] = useState({
    url: "",
  });

  useEffect(() => {
    let linkUrl;
    let typeNotification = props.data.type;
    let idNotification = props.data.item_id;
    switch (typeNotification) {
      case "webinar":
        linkUrl = `/Webinar/InnerWebinar/${idNotification}`;
        break;
      case "learningContent":
        linkUrl = `/education/category/${idNotification}`;
        break;
      case "course":
        linkUrl = `/education/mycourses/${idNotification}`;
        break;
      case "lottery":
        linkUrl = `/Lottery/LotteryDetail/${idNotification}`;
        break;
      case "news":
        linkUrl = `/news/inner-page/${idNotification}`;
        break;
      default:
        linkUrl = 0;
        break;
    }
    setState({
      ...state,
      url: linkUrl,
    });
  }, []);

  return (
    <div className="item-notification_list">
      {state.url == 0 ? (
        <a>{props.data.title}</a>
      ) : (
        <Link to={state.url}>
          {props.data.title} {props.data.read == 1 ? null : <b />}
        </Link>
      )}
      <p>{props.data.description}</p>
      <span>{props.data.jtime}</span>
    </div>
  );
};

export default ItemNotification;
